import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from 'components/Button';
import { RemoveItemModalFooter, RemoveItemModalText } from '../EcosystemData/style';

const getYear = (yearInput) => {
  if (!yearInput) return ''; // Handle null, undefined, or empty string
  if (/^\d{4}$/.test(yearInput)) return yearInput; // If already a four-digit year, return it
  const date = new Date(yearInput);
  return isNaN(date) ? '' : date.getFullYear().toString(); // Parse date and get year, or return empty string if invalid
};


const RemoveEcologicalIntegrityModal = ({ closeModal, confirmRemove, item }) => {
  return (
    <>
      <RemoveItemModalText data-testid="modal-body">
        Are you sure you want to permanently remove the irreplaceability of year{' '}
        <b>{getYear(item?.year)}</b> from the list? This action cannot be undone.
      </RemoveItemModalText>
      <RemoveItemModalFooter>
        <Button type="secondary" onClick={closeModal}>
          <FormattedMessage id="cancel" />
        </Button>
        <Button type="destructive" onClick={confirmRemove}>
          <FormattedMessage id="yesRemove" />
        </Button>
      </RemoveItemModalFooter>
    </>
  );
};

export default RemoveEcologicalIntegrityModal;